import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';

const styles = {
    kolicinaIcijena: {
        fontFamily: 'monospace'
    }
};

export default class FixedMeduskladisnicaBodyCells extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Table.Cell textAlign="right" collapsing style={styles.kolicinaIcijena}>
                    {this.props.item.kolicina}
                </Table.Cell>
            </React.Fragment>
        );
    }
}

FixedMeduskladisnicaBodyCells.propTypes = {
    item: PropTypes.object.isRequired
};
